module.exports = __webpack_public_path__ + "static/media/image2.6147ca83.png";